<!--
 * @FileDescription: 店铺设置（注释描述）
 * @Author: xy（作者）
 * @Date: 2020-04-15（时间）
 * @LastEditors: xy（最后更新人）
 * @LastEditTime: 2020-04-15（最后更新时间）
 -->
<template>
    <div class="page-container basics">
        <div class="page-container-height ">
            <div class="basic-title">
                <div class="department-add"  @click="onPage(1)">
                    <img src="@/assets/image/basic-add@2x.png"/>
                    <span>新增门店</span>
                </div>
            </div>
            <div class="basic-content div-overflow">
                <div class="basics-li" v-for="(item,index) in shopObj" :key="index" :class="item.state == 1 ? 'basics-li-now' : ''">
                    <div class="basics-lis" >
                        <img src="@/assets/image/shop-now.png" class="basics-now" v-if="item.storeFlag == 1"/>
                        <span class="basics-li-storeName">{{item.storeName}}</span>
                        <div class="basics-li-img" v-if="isEmpty(item.storeUrlMap.inStorePhotos)">
                            <img src="@/assets/image/dianpu@2x.png"/>
                        </div>
                        <img :src="item.storeUrlMap.inStorePhotos" v-else class="basics-li-img"/>
                        <div class="basics-li-shop" @click="onPage(3,item)">进入门店</div>
                        <div class="basics-li-edit" @click="onPage(2,item)" >设置门店</div>
                    </div>
                </div>
            </div>
        </div>
        <basicsModel ref="basicsModel" :basicItem="basicItem" @onResh="onResh"></basicsModel>
    </div>
</template>
<script>
    import picture from "@/components/upload/picture.vue"
    import { storeList, getJurisdiction } from '@/utils/api'
    import basicsModel from './model/basicsModel'
    export default {
        data() {
            return {
                disabled:true,
                disabled1:true,
                form: this.$form.createForm(this),
                basicItem:{},
                shopObj:[]
            }
        },
        methods: {
            //店铺列表
            getList(){
                storeList({},{},{
                    companyId:this.$store.state.companyId,
                    companyStoreId:this.$store.state.shopId,
                }).then((res)=>{
                    if(res.success){
                        this.shopObj = res.result
                    }
                })
            },
            onResh(){
              this.getList()
            },
            onPage(index,item){
                if(index == 1){
                    this.$refs.basicsModel.onOpen(index)
                }else if(index == 2){
                    this.basicItem = item
                    this.$refs.basicsModel.onOpen(index,item)
                }else if(index == 3){
                    if(item.state == 1){
                        return;
                    }
                    let params = new FormData()
                    // params.append("accountId",item.accountId)
                    params.append("storeId",item.id)
                    getJurisdiction(params).then(res1 => {
                        if (res1.success) {
                            this.add_Routes(res1.result)
                            this.$store.state.oneMenuNum = 0
                            if(this.isEmpty(res1.result.storeType)){
                                    this.$store.state.storeType = 1
                            }else{
                                this.$store.state.storeType = res1.result.storeType
                            } 
                            localStorage.setItem('storeType',this.$store.state.storeType)                 
                            this.$store.state.menuId = res1.result[0].children[0].children[0].accountId
                            sessionStorage.setItem('routes', JSON.stringify(res1.result))
                            this.$router.push({ path: '/systemoverview/overview/home' })
                            this.$store.state.shopId = res1.result[0].companyStoreId
                            this.$store.state.companyId = res1.result[0].companyId
                            sessionStorage.setItem('accountType',res.result.accountType)
                            // 保持登录后一级菜单在首页
                            sessionStorage.setItem('oneMenuNum', 0)
                            sessionStorage.setItem('btnPermissions', JSON.stringify(res1.result.buttonLable))
                        }else{
                            this.$message.warn(res1.logMessage)
                        }
                    })
                }
            },
        },
        components:{
            'v-picture':picture,
            basicsModel,
        },
        watch:{

        },
        mounted(){
            this.getList()
        },
        created(){

        }
    }
</script>

<style lang="scss" scoped>
    .page-container-height{
        height: calc(100vh - 130px);
        overflow: hidden;
        background: #FFFFFF;
        padding: 20px 60px 60px;
        .basic-title{
            .btn-basic-add{
                border-radius: 18px !important;
                margin-left: 35px;
            }
            .basic-btn{

            }
        }
        .basic-content{
            height: calc(100vh - 320px);
            overflow: auto;
            padding-top: 30px;
            display: flex;
            flex-wrap: wrap;
            padding-left: 20px;
            .basics-li{
                position: relative;
                width: 290px;
                height: 312px;
                box-shadow:0px 6px 14px 0px rgba(52,128,254,0.14);
                margin-right:43px;
                margin-bottom: 30px;
            }
            .basics-li:hover{
                transform: scale(1.02);
            }
            .basics-lis{
                position: absolute;
                top: -4px;
                left: 50%;
                z-index: 10;
                transform: translateX(-50%);
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
                width: 312px;
                height: 312px;
                box-shadow:0px 6px 14px 0px rgba(52,128,254,0.14);
                background-color: #fff;
                .basics-now{
                    position: absolute;
                    top: 0;
                    right: 0;
                    width: 79px;
                    height: 59px;

                }
                .basics-li-storeName{
                    color: #333333;
                    font-size: 16px;
                    font-weight: 700;
                }
                .basics-li-img{
                    width:120px;
                    height:120px;
                    background:rgb(243, 186, 186);
                    border-radius:6px;
                    margin: 18px 0 27px 0;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    object-fit: cover;
                    img{
                       width: 40px;
                    }
                }
                .basics-li-shop{
                    width:140px;
                    height:32px;
                    background:rgba(255,255,255,1);
                    border:1px solid var(--co);
                    border-radius:2px;
                    color: var(--co);
                    text-align: center;
                    line-height: 32px;
                    cursor: pointer;
                }
                .basics-li-shop:hover{
                    background: var(--co);
                    color: #ffffff;
                }
                .basics-li-edit{
                    width:140px;
                    height:32px;
                    background:rgba(250,250,250,1);
                    border:1px solid rgba(235,235,235,1);
                    border-radius:2px;
                    text-align: center;
                    line-height: 32px;
                    margin-top: 10px;
                    cursor: pointer;
                }
            }
            .basics-li-now{
                .basics-li-shop{
                    border:1px solid #ddd;
                    color: #ccc;
                }
            }
            .basics-lis:hover{
                transition: scale(1.02);
            }
        }
    }
</style>
